import React, { useEffect } from 'react'
import FaqGovernmentActRegulationsUI from '../component/FaqGovernmentActRegulationsUI'

const FaqGovernmentActRegulations = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return ( <
        FaqGovernmentActRegulationsUI / >
    )
}

export default FaqGovernmentActRegulations